import styled from "@emotion/styled";
import { useMediaQuery } from "@mui/material";
import WebpImage from "@src/component/base/WebpImage";
import { EmptySpace } from "@src/component/SignComponent";
import useUser from "@src/hook/useUser";
import { faqListExpert } from "@src/model/applicationModel";
import { Empty, GroupA } from "@src/ruix";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Autoplay, Pagination, Scrollbar } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";
import {
	CIListContainer,
	CListPagination,
	ContentsContainerMobile,
	ExpertCtaContentsContainer,
	ExpertCtaContentsInnerMobile,
	ExpertMainContentsContainerMobile,
	ExpertMainCtaButtonMobile,
	ExpertProcessCardListMobile,
	ExpertReviewCard,
	ExpertReviewData,
	ExpertTrustCard,
	ExpertWhyOnpointData,
	FAQAnswerDiv,
	ResponsibilityCard,
	ResponsibilityData,
	ReviewContainer,
	SectionSubTitleMobile,
	SectionTitleMobile,
	TrustData,
	WhyOnePointBox,
	WhyOnePointDiv,
} from "../../base/BaseContents";
import { FAQSection } from "../../main/pc/MainContents";

export const ExpertContentsMobile = () => {
	const { user } = useUser();
	const router = useRouter();

	const [lastScrollTop, setLastScrollTop] = useState(0);

	const isScrollingUp = () => {
		const currentScrollTop = window.scrollY;
		const scrollingUp = currentScrollTop < lastScrollTop;
		setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
		return scrollingUp;
	};

	useEffect(() => {
		const scrollFunction = () => {
			if (
				scrollY > (document.querySelector("#expert-apply-mid") as any)?.offsetHeight &&
				!isScrollingUp()
			) {
				document.querySelector("#floating-btn")?.classList.remove("hidden");
			} else {
				document.querySelector("#floating-btn")?.classList.add("hidden");
			}
		};
		window.addEventListener("scroll", scrollFunction);
		return () => {
			window?.removeEventListener("scroll", scrollFunction);
		};
	}, [lastScrollTop]);

	const 플로팅버튼 = () => (
		<>
			<div
				onClick={() => {
					router.push("/match/my?type=expert");
				}}
				id="floating-btn"
				className="hidden"
			>
				<div>지금 바로 지원하기</div>
			</div>
		</>
	);

	return (
		<>
			<ExpertMainContentsContainerMobile className="column-center-start">
				<MainCtaContents />
				<TrustSection />
				<ReviewSection />
				<WhyOnePoint />
				<OnePointResponsibility />
				<Process />
				<CIList />
				{플로팅버튼()}
				<FAQSection list={faqListExpert[0]} />
			</ExpertMainContentsContainerMobile>
		</>
	);
};

const MainCtaContents = () => {
	const { user } = useUser();
	const router = useRouter();
	return (
		<ExpertCtaContentsContainer className="column-center-center">
			<ContentsContainerMobile className="column-center-center">
				<ExpertCtaContentsInnerMobile className="column-center-start">
					<h1
						className="cta-title-box"
						style={{
							margin: "0 auto",
						}}
					>
						<div className="row-center-center">
							<span>상위 10% 마케터를 위한</span>
						</div>
						<div className="row-center-center">
							<span>{"프리랜서 플랫폼"}</span>
						</div>
					</h1>

					<ExpertMainCtaButtonMobile
						variant="outlined"
						id="expert-apply-mid"
						onClick={() => {
							router.push("/match/my?type=expert");
						}}
					>
						지금 바로 지원하기
					</ExpertMainCtaButtonMobile>
				</ExpertCtaContentsInnerMobile>
			</ContentsContainerMobile>
		</ExpertCtaContentsContainer>
	);
};

const WhyOnePointSections = () => {
	const a = 1;

	return (
		<>
			{ExpertWhyOnpointData.map((section, index) => (
				<React.Fragment key={index}>
					<EmptySpace space={40} />
					<WhyOnePointBox className={"column-center-center"}>
						<WhyOnePointDiv className="column-center-center">
							<div
								className="label"
								style={{
									textAlign: "center",
								}}
							>
								{section.label}
							</div>

							<WebpImage width={120} src={section.image} alt={section.label} />
							<div
								style={{
									textAlign: "center",
								}}
								className="title"
							>
								{section.title}
							</div>
							<div
								style={{
									textAlign: "center",
								}}
								className="description"
							>
								{section.description.split("\n").map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</div>
						</WhyOnePointDiv>
					</WhyOnePointBox>
				</React.Fragment>
			))}
		</>
	);
};

const WhyOnePoint = () => {
	const a = 1;
	return (
		<ContentsContainerMobile className="column-center-start">
			<SectionTitleMobile>왜 원포인트 인가요?</SectionTitleMobile>
			{WhyOnePointSections()}
		</ContentsContainerMobile>
	);
};

const OnePointResponsibility = () => {
	const a = 1;

	const isPc = useMediaQuery("(min-width: 1024px)");

	return (
		<ContentsContainerMobile className="column-center-start">
			<SectionTitleMobile>{"원포인트가\n확실히 책임져요"}</SectionTitleMobile>
			<EmptySpace space={40} />
			<GroupA order={isPc ? "row-center-center" : "column-center-center"} gap={32}>
				{ResponsibilityData.map((data, index) => (
					<ResponsibilityCard key={index} className="column-center-center">
						<WebpImage
							className="responsibility-img"
							src={data.image}
							alt={data.title}
						/>
						<div
							className="title"
							style={{
								textAlign: "center",
							}}
						>
							{data.title}
						</div>
						<div
							className="desc"
							style={{
								textAlign: "center",
							}}
						>
							{data.desc}
						</div>
					</ResponsibilityCard>
				))}
			</GroupA>
		</ContentsContainerMobile>
	);
};

const ReviewSection = () => {
	const chunkArray = <T,>(array: T[], size: number) =>
		array.reduce((acc, _, index) => {
			if (index % size === 0) acc.push(array.slice(index, index + size));
			return acc;
		}, [] as T[][]);

	// 3개씩 그룹으로 나누기
	const groupedData = chunkArray(ExpertReviewData, 1);
	return (
		<ContentsContainerMobile>
			<ReviewContainer>
				<SwiperComponent
					modules={[Pagination, Scrollbar, Autoplay]}
					slidesPerView={1}
					slidesPerGroup={1}
					centeredSlides={false}
					loop={true}
					spaceBetween={20}
					pagination={{
						clickable: true,
						el: ".c-list-pagination2",
					}}
					autoplay={{
						delay: 3000,
						disableOnInteraction: true,
						pauseOnMouseEnter: true,
					}}
					breakpoints={{
						820: {
							slidesPerView: 3,
							slidesPerGroup: 3,
							spaceBetween: 20,
							centeredSlides: false,
							autoplay: {
								delay: 5000,
								disableOnInteraction: true,
								pauseOnMouseEnter: true,
							},
						},
					}}
				>
					{groupedData.map((group, i) => (
						<SwiperSlide key={`review-group-${i}`}>
							<div
								className="card-container column-center-center"
								style={{
									gap: 10,
								}}
							>
								{group.map((v, j) => (
									<ExpertReviewCard key={`review-${i}-${j}`}>
										<GroupA order="column-center-start" gap={16}>
											<GroupA order="column-center-start" gap={8}>
												<div className="title">{v.title}</div>
												<div className="desc">{v.description}</div>
											</GroupA>
											<GroupA order="column-start-start" gap={8} fullWidth>
												<div className="name row-center-center">
													<span>{v.position}</span>
													<span className="name-gray">{v.name}</span>
												</div>
											</GroupA>
										</GroupA>
									</ExpertReviewCard>
								))}
							</div>
						</SwiperSlide>
					))}
				</SwiperComponent>
			</ReviewContainer>
			<EmptySpace space={24} />
			<CListPagination className="c-list-pagination2 row-center-center"></CListPagination>
		</ContentsContainerMobile>
	);
};

const Process = () => {
	const isPc = useMediaQuery("(min-width: 1024px)");
	return (
		<ContentsContainerMobile
			className="column-center-start"
			style={{
				padding: "64px 0",
				background: "var(--bg-white)",
			}}
		>
			<GroupA order="column-center-center" gap={0}>
				<SectionTitleMobile>{`등록 프로세스`}</SectionTitleMobile>
				<SectionSubTitleMobile>
					{"3단계 프로세스로\n하드 및 소프트 스킬을 검증합니다"}
				</SectionSubTitleMobile>
			</GroupA>
			<EmptySpace space={40} />
			<GroupA order={"column-start-start"} gap={16} fullWidth>
				{ExpertProcessCardListMobile.map((item, index) => (
					<WhyCard
						key={"ExpertProcessCard" + index}
						imgSrc={item.imgSrc}
						title={item.title}
						subTitle={item.subTitle}
					/>
				))}
			</GroupA>
		</ContentsContainerMobile>
	);
};

const WhyCard = (props: { imgSrc: string; title: string; subTitle: string }) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<WhyCardBoxMobile>
			<WebpImage
				style={{
					width: "56px",
					height: "56px",
				}}
				src={imgSrc}
				alt=""
			/>
			<GroupA order="column-start-start" gap={0}>
				<div className="title">{title}</div>
				<div className="subTitle">{subTitle}</div>
			</GroupA>
		</WhyCardBoxMobile>
	);
};

const WhyCardBoxMobile = styled.div`
	display: flex;
	flex: 1;
	padding: 16px 10px;
	width: 100%;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	gap: 8px;
	border-radius: 4px;

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

const TrustSection = () => {
	const a = 1;
	return (
		<ContentsContainerMobile className="column-start-start">
			<GroupA fullWidth order="column-center-center" gap={0}>
				<FAQAnswerDiv>왜 프리랜서로 일해야 하나요?</FAQAnswerDiv>
				<Empty space={20} />
				<SectionTitleMobile>잘하는 일로 수입도 만들고</SectionTitleMobile>
				<SectionTitleMobile>{"더 성장하고 싶다면"}</SectionTitleMobile>
			</GroupA>
			<Empty space={20} />
			<GroupA fullWidth order="column-center-center" gap={8}>
				{TrustData.map((data, index) => (
					<ExpertTrustCard key={index} className="column-center-center">
						<GroupA order="row-center-center" gap={0} fullWidth>
							<div className="num">{data.num}</div>
							<div className="numstr">{data.numstr}</div>
						</GroupA>
						<div className="title">{data.title}</div>
					</ExpertTrustCard>
				))}
			</GroupA>
		</ContentsContainerMobile>
	);
};

const CIList = () => {
	//
	const a = 1;
	return (
		<ContentsContainerMobile className="column-center-start">
			<SectionTitleMobile>성장하는 기업과 함께하세요</SectionTitleMobile>
			<EmptySpace space={40} />
			<CIListContainer className="row-center-between">
				<WebpImage src="/onepoint/images/renewal/ci-section/1-1.png" alt="company1-1" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-2.png" alt="company1-2" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-3.png" alt="company1-3" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-4.png" alt="company1-4" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-5.png" alt="company1-5" />
				<WebpImage src="/onepoint/images/renewal/ci-section/1-6.png" alt="company1-6" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-7.png" alt="company1-7" />

				<WebpImage src="/onepoint/images/renewal/ci-section/1-8.png" alt="company1-8" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-1.png" alt="company2-1" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-2.png" alt="company2-2" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-3.png" alt="company2-3" />

				<WebpImage src="/onepoint/images/renewal/ci-section/2-4.png" alt="company2-4" />
			</CIListContainer>
			<EmptySpace space={60} />
		</ContentsContainerMobile>
	);
};
